<div class="app-container">
    <div [ngClass]="!isTrackingEnabled ? 'inactive-trip-card' : 'active-trip-card'">
        <div class="inactive-trip-banner">
            <div class="inactive-trip-banner-left">
                <img src="logo.png" />
                <p *ngIf="tripStatusCode >= 0">{{TripCategory}}</p>
            </div>
            <div *ngIf="HelplineNumber && tripStatusCode >= 0" class="inactive-trip-banner-right">
                <!-- img *ngIf="tripStatusCode > 2" src="feedback.svg" alt="Feedback Image" -->
                <img src="helpdesk.svg" alt="Help desk Image" (click)="openHelpDeskDialer()" />
            </div>
        </div>
        
        <div *ngIf="!isTrackingEnabled">
            <div class="trip-info-container">
                <img src="car.svg" alt="Escort Image" class="escort-img">
                <p *ngIf="tripStatusCode != -1" class="trip-timing">Trip Starts at {{ StartDate | date: 'dd MMM' }} - {{startTime}}</p>
                <p *ngIf="tripStatusCode != -1" class="trip-info-label">Tracking will be enabled 30 mins before start time</p>
                <p *ngIf="tripStatusCode == -1" class="trip-info-label">Trip is already completed or link is invalid</p>
            </div>
        </div>
        <div [ngClass]="isTrackingEnabled ? 'google-map' : ''" id="map"></div>

        <div class="trip-card" *ngIf="tripStatusCode >= 0" #tripCard>
            <div class="trip-category" id="tripCategory" (click)="toggleExpandExt()" >
                {{TripCategory}}
                <img class="dropdown-icon" id="dropdownIcon" src="expandcollapse.svg" alt="Expand collapse Image">
            </div>
            <div class="driver-info" *ngIf="driverName">
                <img *ngIf="DriverPicture" src="{{DriverPicture}}" alt="Driver Image" class="driver-img">
                <div class="driver-details">
                    <div class="vehicle-id">{{vehicleName}}</div>
                    <div class="driver-name">{{driverName}}</div>
                </div>
                <div *ngIf="tripStatusCode <= 3 && HelplineNumber" class="phone-icon" id="calldriver" (click)="openDialer()"><img src="call.svg" alt="Call Driver" class="dial-img"></div>
                <div *ngIf="tripStatusCode > 3 || !HelplineNumber"  class="" id="">&nbsp;</div>
            </div>
            <div class="content-collapsible expanded" id="contentCollapsible" >
                <div class="escort-info" *ngIf="guardName != null && guardName != ''">
                    <div *ngIf="GuardImage" class="guard-image-container">
                        <img src="{{GuardImage}}" alt="Escort Image" class="escort-img">
                        <img src="shield.svg" alt="Escort Image" class="guard-img">
                    </div>
                    <div>
                        <span class="guard-name">{{guardName}}</span>
                        <span class="guard-action">{{guardAction}}</span>
                    </div>
                </div>
            
                <div class="timeline-container">
                    <div class="timeline">
                        <div class="circle-outline"></div>
                        <div class="connector"
                        [ngStyle]="{ height: getMinifiedAddress(startLocation).length <= 25 ? '45px' : '60px' }">
                        </div>
                        <div class="circle"></div>
                    </div>
                    <div class="addresses">
                        <div class="address" title="{{startLocationFullText}}">
                        <div class="location">{{getMinifiedAddress(startLocation)}}</div>
                        <span class="time">{{startTime}}</span>
                        </div>
                        <div class="address" title="{{destinationLocationFullText}}">
                        <div class="location">{{getMinifiedAddress(destinationLocation)}}</div>
                        <span class="time">{{endTime}}</span>
                        </div>
                    </div>
                </div>
                <div class="view-route-container">
                    <!--a href="#" class="view-route">View Route</a-->
                    &nbsp;
                </div>

                <div class="vehicle-status">
                    <span><img src="checkcircle.svg" alt="Status Image"></span>{{tripStatus}}
                </div>
                <div class="additional-info" *ngIf="!isTrackingEnabled">More details will be available during start time</div>
            </div>
            <div *ngIf="!isExpanded && !isTrackingEnabled">
                <div class="vehicle-status">
                    <span><img src="checkcircle.svg" alt="Status Image"></span>{{tripStatus}}
                </div>
                <div class="additional-info" *ngIf="!isTrackingEnabled">More details will be available during start time</div>
            </div>
            <div class="sos-otp" *ngIf="isTrackingEnabled && tripStatusCode <= 4">
                <div class="sos-button" (click)="sendSOS()" *ngIf="isEmployeeBoarded && tripStatusCode <=4">
                    <span class="sos-icon">
                        <img src="sos.svg" alt="SOS Image">
                    </span> SOS
                </div>
                <div class="otp-section" *ngIf="currentETA && tripStatusCode <=3">
                    <div class="otp-code">{{currentETA}}</div>
                    <div class="otp-label">ETA</div>
                </div>
                <div class="otp-section" *ngIf="isStarted && tripStatusCode <=4">
                    <div class="otp-code">{{nextOTP}}</div>
                    <div class="otp-label">{{ isEmployeeBoarded ? 'Check-out OTP' : 'Check-in OTP' }}</div>
                </div>
            </div>
        </div>
    </div>
</div>
